/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TB License Platform API
 * Lean v1 controlled-pilot contract. One active Product Key allocates one
 * seat and may authorize at most one active Activation. Product Keys and
 * Activation Secrets are write-only delivery credentials and never appear in
 * admin read responses.
 *
 * OpenAPI spec version: 1.1.0
 */

export type APIActivityFiltersFailureStage = typeof APIActivityFiltersFailureStage[keyof typeof APIActivityFiltersFailureStage];


export const APIActivityFiltersFailureStage = {
  request_validation: 'request_validation',
  rate_limit: 'rate_limit',
  authentication: 'authentication',
  policy: 'policy',
  proof: 'proof',
  signing: 'signing',
  persistence: 'persistence',
  response: 'response',
  unknown: 'unknown',
} as const;
